// src/components/shop/ShopButton.js
//
// "🛍 Shop" — opens the shop & closet. Sits beside the coin counter on the
// student dashboard and on every subject page.

import React, { useState } from "react";
import ShopPopup from "./ShopPopup";
import "./shop.css";

// educator: no power-ups tab (those are for students' Treasure Quest); prices
// are the same for everyone.
const ShopButton = ({ avatarUrl, className = "", educator = false }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button type="button" className={`sbl-shop-open ${className}`} onClick={() => setOpen(true)}>
        <span aria-hidden="true">🛍</span> Shop
      </button>
      {open && <ShopPopup avatarUrl={avatarUrl} educator={educator} onClose={() => setOpen(false)} />}
    </>
  );
};

export default ShopButton;
